import { render, staticRenderFns } from "./ExpertDetail.vue?vue&type=template&id=2c3e877e&scoped=true"
import script from "./ExpertDetail.vue?vue&type=script&lang=ts"
export * from "./ExpertDetail.vue?vue&type=script&lang=ts"
import style0 from "./ExpertDetail.vue?vue&type=style&index=0&id=2c3e877e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3e877e",
  null
  
)

export default component.exports